import { getRequest } from '../services/requestHandler';
import { AppUserMenuPageAttribute } from '../models';

export const getAppUserMenuPageAttributes = async (userId: string) => {
  const url = `/app/getappusermenupageattributes?appUserId=${userId}`;

  const response = await getRequest<AppUserMenuPageAttribute>('GetAppUserMenuPageAttributes', url);
  return response;
};
